export default "__VITE_ASSET__83e75056__"